import { Component, input } from '@angular/core';
import { AdvertViewModel } from '@models/advert/advert';
import { AdvertRoomsLabelComponent } from '../../advert-rooms-label/advert-rooms-label.component';
import { ViewUnitIntranetComponent } from '../../view-unit-intranet/view-unit-intranet.component';
import { ViewUnitAcmComponent } from '../../view-unit-acm/view-unit-acm.component';
import { TranslateModule } from '@ngx-translate/core';
import { NumeralPipe } from '../../../../pipes/numeral.pipe';
import { ConvertDatePipe } from '@pipes/convert-date.pipe';

@Component({
    selector: 'apartment-sale-header-stats',
    templateUrl: './apartment-sale-header-stats.component.html',
    imports: [AdvertRoomsLabelComponent, ViewUnitIntranetComponent, ViewUnitAcmComponent, TranslateModule, NumeralPipe, ConvertDatePipe]
})
export class ApartmentSaleHeaderStatsComponent {
    readonly advert = input<AdvertViewModel>(undefined);
}
